import { baseApi } from '@/services/api';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CreateCustomRequest, CustomCategory, CustomsResponse, GetCustomsParams, ManualCustomRequest, UpdateCustomRequest, Venue } from './customTypes';
import { Custom } from './customTypes';

const user = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')!) : null;
const userRole = user?.userType || null;

const customBaseQuery = fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
        if (headers.has('Content-Type')) {
            headers.delete('Content-Type');
        }
        return headers;
    },
});

export const customAPI = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getCustoms: builder.query<CustomsResponse, GetCustomsParams | any>({
            query: (params = {}) => ({
                url: `/custom/${userRole}/${params}`,
                method: 'GET',
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ event_id }) => ({
                            type: 'Customs' as const,
                            id: event_id,
                        })),
                        { type: 'Customs', id: 'LIST' },
                    ]
                    : [{ type: 'Customs', id: 'LIST' }],
        }),

        getCustom: builder.query<Custom, GetCustomsParams | any>({
            query: (id) => ({
                url: `/custom/${userRole}/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Events', id }],
        }),

        createCustom: builder.mutation<Custom, GetCustomsParams | any>({
            query: (params) => ({
                url: `/custom/${userRole}/${params?.path}`,
                method: 'POST',
                data: params?.data,
            }),
        }),

        createManualCustom: builder.mutation<Custom, any>({
            query: (event) => ({
                url: '/contacts',
                method: 'POST',
                data: event,
            }),
        }),

        updateCustom: builder.mutation<Custom, { id: any; data: UpdateCustomRequest }>({
            query: ({ id, data }) => ({
                url: `/custom/${userRole}/${id}`,
                method: 'PUT',
                data: data,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'Events', id },
                { type: 'Events', id: 'LIST' },
            ],
        }),

        deleteCustom: builder.mutation<void, string>({
            query: (id) => ({
                url: `${userRole}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Events', id: 'LIST' }],
        }),
        genericRequest: builder.mutation<any, {
            url: string;
            method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
            data?: any;
            params?: any;
            headers?: any
        }>({
            query: ({ url, method = 'GET', data, params, headers }) => ({
                url,
                method,
                data: data,
                params,
                headers
            }),
        }),

    }),
});

export const {
    useGetCustomsQuery,
    useLazyGetCustomsQuery,
    useGetCustomQuery,
    useCreateCustomMutation,
    useCreateManualCustomMutation,
    useUpdateCustomMutation,
    useDeleteCustomMutation,
    useGenericRequestMutation,
} = customAPI;
